export * from "modules/KioskDashboard/components/KioskLabelsModal/hooks/useKiosksLabelsQuery";
